import React from "react";

export default function EventInfoCard() {
  return (
    <section
      className="mt-6 mb-6 bg-card rounded-xl border border-border p-4"
      data-testid="event-info-card"
    >
      <div className="flex items-start gap-3">
        <div>
          <p className="font-bold text-lg text-foreground">
            District-Wide Professional Development
          </p>
          <p className="text-accent font-semibold text-xl mt-0.5">
            June 8, 2026
          </p>
          <p className="text-muted-foreground text-lg mt-1 leading-relaxed">
            A full day of learning, collaboration, and innovation—empowering
            educators to shape the future of every learner.
          </p>
        </div>
      </div>
    </section>
  );
}
